export default "__VITE_ASSET__DzCy8Cix__"